import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-form-errors',
    templateUrl: './form.errors.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormErrorsComponent {
  @Input() public errors: any;
}
